import { RSVPResponseType } from './types';

export interface SubmitRsvpCampaignParams {
  eventId: string;
  campaignToken: string;
  response: RSVPResponseType;
  message?: string;
}

export async function submitRsvpCampaignResponse({
  eventId,
  campaignToken,
  response,
  message,
}: SubmitRsvpCampaignParams): Promise<void> {
  try {
    await fetch(`/e/api/${eventId}/rsvp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        campaignToken,
        response,
        ...(message !== undefined && message.trim() !== '' && { message: message.trim() }),
      }),
    });
  } catch (error) {
    throw new Error(`RSVP request failed: ${error}`);
  }
}
